import BaseUseCase from "../../../base_use_case.js";
import Routes from "../../../../admin/routes.js";
class ListPagesUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/frontend/pages`,
      params: params
    }).then((result) => {
      let { data, headers } = result; 
      let { pages } = data; 

      pages = pages.map((page) => {
        return {
          ...page,
          key: page.slug,
          itemLink: Routes.page(page)
        }
      })
      data.list = pages;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListPagesUseCase();
export default instance;